$(document).ready(function () {

  var animItems = $('.js-scroll-anim');

  checkIfElementIsInView();
  $(window)
    .on('scroll resize', checkIfElementIsInView)
    .trigger('scroll');

  function checkIfElementIsInView() {
    var windowHeight = $(window).height(),
      windowTopPosition = $(window).scrollTop(),
      windowBottomPosition = (windowTopPosition + windowHeight);

    $.each(animItems, function () {
      var element = $(this),
        elementTriggerPosition = element.data('trigger') == undefined ? 150 : parseInt(element.data('trigger')),
        elementHeight = element.outerHeight(),
        elementTopPosition = element.offset().top,
        elementBottomPosition = (elementTopPosition + elementHeight);

      // Set transition duration
      if (element.data('duration')) {
        element.css('transition-duration', element.data('duration') + 's');
      }

      if (elementTopPosition + elementTriggerPosition <= windowBottomPosition) { // add (elementBottomPosition >= windowTopPosition) if animation also scroll to top
        element.addClass('in-view');
      } else if (elementTopPosition > windowBottomPosition) { // remove condition if animation also scroll to top
        element.removeClass('in-view');
      }

      // Background parallax effect
      if (element.hasClass('js-scroll-bg')) {
        var elementBgSpeed = element.data('speed') == undefined ? -.2 : element.data('speed');
        element.css('background-position', '50% ' + (elementBgSpeed * windowTopPosition) + 'px');
      }
    });
  }

  if ($('#tv-svg-ring').length) {
    var vivusRing = new Vivus('tv-svg-ring', {
      type: 'sync',
      duration: 1000,
      animTimingFunction: Vivus.EASE_OUT
    });

    vivusRing
      .stop()
      .reset()
      .play(1);
  }

  function isOnScreen() {
    var elem = '.tv-homeContentStoresBlock'
    if ($(elem).length == 0) {
      return;
    }
    var $window = $(window)
    var viewport_top = $window.scrollTop()
    var viewport_height = $window.height()
    var viewport_bottom = viewport_top + viewport_height
    var $elem = $(elem)
    var top = $elem.offset().top
    var height = $elem.height()
    var bottom = top + height

    return (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
  }

  window.addEventListener('scroll', function (e) {
    if (isOnScreen()) {
      jQuery('.tv-homeContentStoresBlock-graph').addClass('chart-is-played')
      jQuery('.tv-homeContentStoresBlock-number').addClass('opacity-added')
    } else {
      jQuery('.tv-homeContentStoresBlock-graph').removeClass('chart-is-played')
      jQuery('.tv-homeContentStoresBlock-number').removeClass('opacity-added')
    }
  });
});
